import React from 'react';
import Grid2 from '@mui/material/Grid2';
import { Box, Typography } from '@mui/material';

import TableFilters from './TableFilters/TableFilters';
import TableColumns from './TableColumns/TableColumns';
import { useTranslation } from 'react-i18next';

const TableFiltersAndColumnSettings = ({
	initialColumns = [],
	filters = {},
	selectedFilters = {},
	selectedColumns = [],
	setSelectedFilters = () => { },
	setSelectedColumns = () => { },
	filteredCount = 0,
	disableFiltersSettings = false,
	disableColumnSettings = false,
	maxColumnsAllowed,
	defaultSelectedColumns = [],
}) => {

	const { t } = useTranslation(['common', 'generic_table']);

	if (disableFiltersSettings && disableColumnSettings) {
		return <></>;
	}

	return (
		<Grid2
			container
			alignItems="center"
			direction="row"
			justifyContent="space-between"
			spacing={1}
			sx={{
				mb: 2,
				bgcolor: '#F8F8F8',
				borderRadius: '10px',
				border: '1px solid #F3F3F3',
				borderTop: '1px solid #F3F3F3',
				p: 1
			}}>
			<Grid2 container direction="row" spacing={1}  >
				{!disableColumnSettings && (
					<TableColumns
						initialColumns={initialColumns}
						selectedColumns={selectedColumns}
						setSelectedColumns={setSelectedColumns} 
						maxColumnsAllowed={maxColumnsAllowed}
						defaultSelectedColumns={defaultSelectedColumns}
					/>
				)}
				
				{!disableFiltersSettings && <TableFilters
					filters={filters}
					selectedFilters={selectedFilters}
					setSelectedFilters={setSelectedFilters} />}
			</Grid2>

			{!disableFiltersSettings && <Box>
				{

					filteredCount > 0 && <Typography variant="fw500s12lh14c3D4B5A" sx={{ mx: 1 }}>{filteredCount} {t('generic_table:results')}</Typography>
				}
			</Box>}
		</Grid2>
	);
};


export default TableFiltersAndColumnSettings;
